document.addEventListener('DOMContentLoaded', () => {
  const cleanForm = (form) => {
    if (form.hasAttribute('data-handled')) {
      return;
    }
    form.setAttribute('data-handled', 'true');

    const cleanClone = form.cloneNode(true);
    cleanClone.removeAttribute('action');

    const inputWishlist = cleanClone.querySelector('[name="properties[_st_wishlist]"]');
    if (inputWishlist) {
      inputWishlist.remove();
    }

    const submitButtons = cleanClone.querySelectorAll('button[type="submit"]');
    submitButtons.forEach(button => {
      button.setAttribute('type', 'button');
    });

    const atcButton = cleanClone.querySelector('button.st-atc-button');
    if (atcButton) {
      atcButton.addEventListener('click', async (event) => {
        event.preventDefault();
        atcButton.classList.add('loading');

        const formData = new FormData(cleanClone);

        try {
          const response = await fetch('/cart/add', {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json'
            }
          });

          if (response.ok) {
            const jsonResponse = await response.json();

            // Trigger notification instead of opening drawer directly
            document.dispatchEvent(new CustomEvent('cart:item-added', {
              detail: {
                items: jsonResponse.items ? jsonResponse.items : [jsonResponse]
              }
            }));

            // Trigger update event for Cha Matte cart drawer
            document.dispatchEvent(new CustomEvent("updateCartDrawer"));
          } else {
            console.error("Falha ao adicionar produto ao carrinho. Response:", response);
          }
        } catch (error) {
          console.error("Erro ao adicionar produto ao carrinho:", error);
        } finally {
          atcButton.classList.remove('loading');
        }
      });
    }

    cleanClone.addEventListener('submit', (event) => {
      event.preventDefault();
    });

    form.parentNode.replaceChild(cleanClone, form);
  };

  // Initial check
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    if (form.querySelector('.st-atc-button')) {
      cleanForm(form);
    }
  });

  // Observer for Swishlist dynamic content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('form[action="/cart/add"]') && node.querySelector('.st-atc-button') && !node.hasAttribute('data-handled')) {
            cleanForm(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('form[action="/cart/add"]').forEach(form => {
              if (form.querySelector('.st-atc-button') && !form.hasAttribute('data-handled')) {
                cleanForm(form);
              }
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
